<template>
  <div
    class="rounded-full flex items-center justify-center select-none"
    :class="sizeClasses"
    :style="{ background: bgColor }"
  >
    <span v-if="resolvedEmoji" :class="emojiClasses">{{ resolvedEmoji }}</span>
    <span v-else class="font-bold text-white" :class="initialClasses">{{ fallbackInitial }}</span>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { usePreferencesStore } from '@/stores/preferencesStore';
import { useStudentStore } from '@/stores/studentStore';

const props = defineProps({
  studentId: { type: String, default: null },
  emoji: { type: String, default: null },
  size: { type: String, default: 'md' }, // 'sm' | 'md' | 'lg'
});

const preferencesStore = usePreferencesStore();
const studentStore = useStudentStore();

const resolvedEmoji = computed(() => {
  if (props.emoji) return props.emoji;
  if (props.studentId) return preferencesStore.getAvatar(props.studentId);
  return null;
});

const student = computed(() =>
  props.studentId ? studentStore.students.find(s => s.id === props.studentId) : null
);

const fallbackInitial = computed(() => {
  if (!student.value?.name) return '?';
  return student.value.name.split(' ').map(n => n[0]).join('').toUpperCase();
});

const bgColor = computed(() => resolvedEmoji.value ? 'var(--mt-bg-subtle)' : '#2563eb');

const sizeClasses = computed(() => ({
  'w-8 h-8': props.size === 'sm',
  'w-12 h-12': props.size === 'md',
  'w-16 h-16': props.size === 'lg',
}));

const emojiClasses = computed(() => ({
  'text-lg': props.size === 'sm',
  'text-2xl': props.size === 'md',
  'text-3xl': props.size === 'lg',
}));

const initialClasses = computed(() => ({
  'text-xs': props.size === 'sm',
  'text-base': props.size === 'md',
  'text-xl': props.size === 'lg',
}));
</script>
